export default function() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/noop.js
// module id = 170
// module chunks = 0